import i18n from '@/lib/language'
export const accountFields = [
  {
    type: 'input',
    modelKey: 'username',
    props: {
      placeholder: i18n.t('message["1015"]')
    },
    rules: {
      required: true,
      pattern: /^[a-zA-Z0-9_-]{3,15}$/
    },
    messages: {
      required: i18n.t('message["1567"]'),
      pattern: '3-15' + i18n.t('message["369"]')
    }
  },
  {
    type: 'input',
    modelKey: 'password',
    props: {
      placeholder: i18n.t('message["1028"]'),
      type: 'password'
    },
    rules: {
      required: true,
      custom: (value) => {
        return value.length >= 8
      }
    },
    messages: {
      required: i18n.t('message["634"]'),
      custom: i18n.t('message["633"]')
    }
  }
]

export const loginFields = [
  {
    type: 'input',
    modelKey: 'mobile',
    label: '',
    props: {
      placeholder: i18n.t('message["1112"]'),
      maxlength: 11
    },
    rules: {
      type: 'tel'
    }
  },
  {
    type: 'input',
    modelKey: 'checkcode',
    label: '',
    props: {
      placeholder: i18n.t('message["1433"]')
    }
  }
]

export const options = {
  scrollToInvalidField: true,
  layout: 'classic'
}
